export class Invoice {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  invoiceNumber: string;
  tagline: string;
  items: InvoiceItem[];
}


export class InvoiceItem {
  name: string;
  size: string;
  quantity: number;

}



// WEBPACK FOOTER //
// ./src/app/models/invoice.ts